<template>
<div>
  <a-page-header style="width: 105%; margin-left: -20px" title="">
    <template slot="tags">
      <a-breadcrumb>
        <a-breadcrumb-item href="">
          <a-icon type="pie-chart" />
          <span>{{ $t('message.customGroup.title1') }}</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <a-icon type="usergroup-add" />
          <span>{{ $t('message.customGroup.title2') }}</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </template>
  </a-page-header>
  <div class="page-title">{{ $t('message.customGroup.title2') }}</div>
  <a-tabs default-active-key="平台标签表" v-model="tabKey">
    <a-tab-pane key="平台标签表" tab="平台标签表">
      <custom-user-group></custom-user-group>
    </a-tab-pane>
      <a-tab-pane key="CDP源表" tab="CDP源表">
      <upload-user-group></upload-user-group>
    </a-tab-pane>
  </a-tabs>
</div>
</template>

<script>
import CustomUserGroup from "@/views/crowd/CustomUserGroup";
import UploadUserGroup from "@/views/crowd/UploadUserGroup";
export default {
  name: "customGroup",
  components: {
    CustomUserGroup,
    UploadUserGroup
  },
  data(){
    return {
      tabKey:'平台标签表'
    }
  },
  mounted() {
    this.tabKey = this.$route.params.tabKey ? this.$route.params.tabKey : '平台标签表'
  }
}
</script>

<style scoped>

</style>